import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { translations } from "./i18n";
import { loadCalendly } from "./utils/calendly";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import YuanSection from "./components/YuanSection";
import Therapies from "./components/Therapies";
import Services from "./components/Services";
import Process from "./components/Process";
import About from "./components/About";
import Testimonial from "./components/Testimonial";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";
import GroupActivities from "./components/GroupActivities";

const STORAGE_KEY = "qhht-lang";

function pickInitialLang() {
  if (typeof window === "undefined") return "es";
  const saved = window.localStorage.getItem(STORAGE_KEY);
  if (saved && ["es", "en", "zh"].includes(saved)) return saved;
  const nav = (navigator.language || "es").toLowerCase();
  if (nav.startsWith("zh")) return "zh";
  if (nav.startsWith("en")) return "en";
  return "es";
}

function HomePage({ t }) {
  return (
    <main>
      <Hero t={t} />
      <YuanSection t={t} />
      <Therapies t={t} />
      <Services t={t} />
      <Process t={t} />
      <About t={t} />
      <Testimonial t={t} />
      <Contact t={t} />
    </main>
  );
}

export default function App() {
  const [lang, setLangState] = useState("es");

  useEffect(() => {
    setLangState(pickInitialLang());
    loadCalendly();
  }, []);

  const setLang = (l) => {
    setLangState(l);
    try {
      window.localStorage.setItem(STORAGE_KEY, l);
    } catch {
      // no-op
    }
    document.documentElement.lang = l;
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const t = translations[lang];

  return (
    <BrowserRouter>
      <div className="App" data-testid="app-root" data-lang={lang}>
        <Navbar lang={lang} setLang={setLang} t={t} />
        <Routes>
          <Route path="/" element={<HomePage t={t} />} />
          <Route path="/grupal" element={<GroupActivities t={t} />} />
        </Routes>
        <Footer t={t} />
        <WhatsAppFloat t={t} />
      </div>
    </BrowserRouter>
  );
}
